import React from 'react';

import HomeProcessStageCard from '../../cards/HomeProcessStageCard/HomeProcessStageCard';

import './HomeProcess.css';

const HomeProcess = () => {
  return (
    <div className='home-process-container'>
      <h1>YOUR JOURNEY TO RECOVERY AND WELLNESS</h1>
      <p className='home-process-text'>
        At Pro Evolution Wellness, we believe that healing is a structured,
        collaborative, and empowering process. Here's what you can expect when
        you start your wellness journey with us:
      </p>
      <div className='home-process-cards-container'>
        <HomeProcessStageCard
          title='1. Initial Assessment'
          leftDesc={`Your first step begins with a comprehensive assessment by one of our experienced practitioners. We take the time to understand your medical history, current concerns, lifestyle factors, and goals. This in-depth evaluation allows us to identify the root cause of your issue—not just the symptoms.`}
        />
        <HomeProcessStageCard
          title='2. Collaborative Care Planning'
          leftDesc={`At Pro Evolution, we go beyond one-dimensional treatment. Our team of physiotherapists, chiropractors, massage therapists, and other specialists work together to design an integrated, customized care plan. This interdisciplinary approach ensures that every aspect of your health is addressed efficiently and effectively.`}
        />
        <HomeProcessStageCard
          title='3. Consistent, Targeted Treatment'
          leftDesc={`Consistency is key to lasting results. With your care plan in place, we implement a schedule of treatments tailored to your goals and lifestyle. Our focus is on measurable progress and patient education—empowering you to stay active in your recovery and prevention journey.`}
        />
        <HomeProcessStageCard
          title='4. Transformation'
          leftDesc={`The ultimate goal is more than recovery—it's transformation. Whether that means returning to sport, living pain-free, or improving your quality of life, we support you every step of the way. Many of our clients go on to exceed their original goals, becoming stronger and more resilient than ever.`}
        />
      </div>
    </div>
  );
};

export default HomeProcess;
